// extracted by mini-css-extract-plugin
export default {"span":"styles-module_span-pibte"};